import { DomainRoundedIcon } from "@l2r-front/l2r-icons"
import {
    styled,
    Typography,
    SIDEBAR_SPACING_MOBILE,
    SIDEBAR_WIDTH,
} from "@l2r-front/l2r-ui"

export const PanelContent = styled("div")(() => ({
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    overflow: "hidden",
    width: "100%",
}))

export const Container = styled("div")(() => ({
    height: "100%",
    width: "100%",
    overflowY: "auto",
}))

export const GridContainer = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["secondary"].light,
    columnGap: theme.spacing(11),
    display: "grid ",
    gridTemplateColumns: "1fr 1fr",
    gridTemplateRows: "1fr 1fr 1fr",
    height: "100%",
    padding: theme.spacing(11),
    rowGap: theme.spacing(11),
    width: "100%",
    minHeight: 800,
}))

export const FlexContainer = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["secondary"].light,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(SIDEBAR_SPACING_MOBILE, SIDEBAR_SPACING_MOBILE, 0, SIDEBAR_SPACING_MOBILE),
    width: "100%",
}))

export const LengthContainer = styled("div", { shouldForwardProp: (prop) => prop !== "isLargeScreen" })(({ theme, isLargeScreen }) => ({
    padding: isLargeScreen ? theme.spacing(2, 10, 0, 10) : theme.spacing(0),
}))

export const NetworkName = styled(Typography, { shouldForwardProp: (prop) => prop !== "isLargeScreen" })(({ theme, isLargeScreen }) => ({
    marginTop: isLargeScreen ? theme.spacing(16) : theme.spacing(4),
    marginLeft: isLargeScreen ? theme.spacing(10) : theme.spacing(15),
    display: "block",
}))

export const NetworkLength = styled(Typography, { shouldForwardProp: (prop) => prop !== "isLargeScreen" })(({ theme, isLargeScreen }) => ({
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "16px",
    fontWeight: "bold",
    marginTop: isLargeScreen ? 0 : theme.spacing(6),
}))

export const SelectionLength = styled("div")(({ theme }) => ({
    alignItems: "center",
    display: "flex",
    gap: theme.spacing(1),
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
}))

export const DomainIcon = styled(DomainRoundedIcon)(({ theme }) => ({
    width: 20,
    height: 20,
    color: theme.palette["action/active"].main,
}))

export const LengthText = styled(Typography)(({ theme }) => ({
    color: theme.palette["text/tertiary"].main,
}))

export const SubNetworkLengthesContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
}))

export const Sidebar = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["common/gray_states"].light,
    display: "flex",
    flexDirection: "column",
    height: "100%",
    width: SIDEBAR_WIDTH,
}))

export const Scrollable = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(6),
    height: "fit-content",
    paddingBottom: theme.spacing(6),
    overflowY: "auto",
    width: "100%",
}))

export const PanelWrapper = styled("div")(() => ({
    overflowY: "auto",
    height: "100%",
    width: "100%",
}))

export const KpiContainer = styled("div")(({ theme }) => ({
    padding: theme.spacing(10),
}))